/**
****************************************************************************************
Project: Readabl
File: NotFound.js
Description: This component will display Page Not Found message to ui screen.
© Healthcare Triangle, Inc
****************************************************************************************
**/

import React from "react";
import { useNavigate } from "react-router-dom";
import * as c from "../../utils/constants/constants";

const NotFound = (props) => {
    const navigate = useNavigate();
    
    const goToHomePage = () => {
        // this function will navigate to dashboard page if user already login else it will redirect to sso app
        if(localStorage.getItem(c.ACCESS_TOKEN)) navigate(`/${c.PAGE_URLS[c.PAGE_DASHBOARD]}`);
        else {
            if(c.SSO == "true") navigate(`/${c.PAGE_URLS[c.SSO_REDIRECT]}`);
            else navigate(`/`);
        }
    }
    return <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", marginTop: "15px" }}>
        <h1 className="not-found-text">404 - Page Not Found</h1>
        <div className="info">
            {" "}
            Please{" "}
            <span className="info-link" onClick={goToHomePage}>
                click here
            </span>{" "}
            to continue {localStorage.getItem(c.ACCESS_TOKEN) ? " using " : " login "} the application.
        </div>
    </div>
}

export default NotFound;